<div (click)="openModel()" class="picker-element" [class.disabled]="disabled">{{model || defaultText}}
    <i class="fas fa-caret-down icon"></i>
</div>
<input style="display: none;" type="number" [(ngModel)]="model" (ngModelChange)="modelChange.emit(model)">